export const formSpaceConcludProject = [
	{
		body: "",
		category: "operaciones",
		subCategory: "interno",
	},
	{
		body: "",
		category: "operaciones",
		subCategory: "proveedores",
	},
	{
		body: "",
		category: "operaciones",
		subCategory: "areas",
	},
	{
		body: "",
		category: "finanzas",
	},
	{
		body: "",
		category: "comercial",
		subCategory: "marketing",
	},
	{
		body: "",
		category: "comercial",
		subCategory: "ventas",
	},
];

export const modalProjectRedItemTab = [
	{
		id: 0,
		titleRadar: `Negociación`,
		title: `Negociación`,
		descriptionform: "Se aceptaron cambios fuera del alcance para mantener una buena relación con cliente.",
		reason: "negotiation",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
	{
		id: 1,
		titleRadar: `Calidad`,
		title: `Calidad`,
		descriptionform: "Se invierten horas al proyecto con el fin de mejorar la calidad y poder cumplir con los estándares de inmersys.",
		reason: "quality",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
	{
		id: 2,
		titleRadar: `Dificultad Técnica no prevista`,
		title: `Dificultad Técnica no prevista`,
		descriptionform: "Cuando surge un problema imprevisto que complica el desarrollo.",
		reason: "technical_difficulty",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
	{
		id: 3,
		titleRadar: `Conocimiento técnico`,
		title: `Conocimiento técnico`,
		descriptionform:
			"Es la curva de aprendizaje del desarrollador asignado al proyecto cuando es la primera vez que implementa o aplica el conocimiento. Incluye el retrabajo por inexperiencia.",
		reason: "technical_knowledge",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
	{
		id: 4,
		titleRadar: `Seguimiento de Gestión`,
		title: `Seguimiento de Gestión`,
		descriptionform:
			"Por falta de buen seguimiento con desarrollo / cliente / proveedor. | No se tuvo el mejor control en el presupuesto / alcance.",
		reason: "management_monitoring",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
	{
		id: 5,
		titleRadar: `Documentación`,
		title: `Falta de Documentación que afecta el alcance`,
		descriptionform: "Cliente proporciona material poco a poco lo que hace que el alcance no se tenga claro desde un inicio.",
		reason: "missing_documentation",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
	{
		id: 6,
		titleRadar: `Cotización`,
		title: `Cotización`,
		descriptionform: "Las horas asignadas al proyecto no correspondían al alcance inicial del proyecto.",
		reason: "quotation",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
	{
		id: 7,
		titleRadar: `Pausa`,
		title: `Pausa`,
		descriptionform:
			"Pausa por un tiempo considerable | Al retomar proyecto se deben retrabajar partes el proyecto y/o el presupuesto varía por cambio de año.",
		reason: "pause",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
	{
		id: 8,
		titleRadar: `Proveedor`,
		title: `Proveedor`,
		descriptionform: "Se tuvo algún problema con el proveedor.",
		reason: "provider",
		inputdisable: 0,
		inputs: {
			comment: "",
			score: 0,
			id: null,
		},
	},
];

export const initProjectRed = () => {
	return modalProjectRedItemTab.map((project) => {
		return {
			...project,
			inputs: {
				comment: "",
				score: 0,
				id: null,
			},
		};
	});
};
export const initGraphProjectRed = () => {
	return modalProjectRedItemTab.map((project) => {
		return {
			name: project.title,
			project: 0,
		};
	});
};
